
import React from "react";
import Login from "./login";
import { useSpinnerContext } from '@contexts';
import { useNavigate, useLocation } from "react-router-dom";
import { useFormSubmission } from "@hooks";
import { sunboundPayProxy } from '@proxies';
import { Constants } from '@shared';

interface LoginValues {
    email: string;
    password: string;
}

const UserLogin = () => {

    const { setSpinnerShow } = useSpinnerContext();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';

    const { setFormState, hasFormError, formError } = useFormSubmission();

    const handleSubmit = async (values: LoginValues) => {

        setSpinnerShow(true);
        try {
            await sunboundPayProxy.login(values.email, values.password);
            navigate(from, { replace: true });
        } catch (error) {
            console.error(error);
            setFormState(`Login failed`);
        }
        setSpinnerShow(false);
    };

    return (
        <div className="flex flex-col bg-white items-center p-5 gap-y-3 min-h-sb">
            <Login submit={handleSubmit}>
                <>
                    <h1 className="page-header">Welcome to Sunbound</h1>
                    <span className="page-subheader">First time user? Check your inbox and spam folder for an email from Sunbound with instructions to set up your password</span>
                    <span className="page-subheader">Still having trouble? Call <a href={`tel:${Constants.Help.Phone}`} className="underline">{Constants.Help.Phone}</a> or email <a href={`mailto:${Constants.Help.Email}`} className="underline">{Constants.Help.Email}</a></span>
                </>
            </Login>
            {
                hasFormError &&
                <p className="text-red-600 text-xl">{formError}</p>
            }
        </div>
    );

};


export default UserLogin;